<div
  *ngIf="config?.layout === 'vertical'"
  class="navbar-content navbar-content--vertical">
  <div class="nav-scroll-area">
    <ng-scrollbar
      class="nav-scroll-area__bar"
      exclude="'#mobile-collapse1'"
      visibility="hover">
      <ul class="nav pcoded-inner-navbar" (clickOutside)="fireOutClick()" (mouseleave)="navMob()">
        <ng-container *ngFor="let item of navigation">
          <app-nav-group *ngIf="item.type === 'group'" [item]="item" [allowedPermissions]="contactNavPermissions" [isPhoneViewport]="isPhoneViewport"></app-nav-group>
          <app-nav-collapse *ngIf="item.type === 'collapse'" [item]="item"></app-nav-collapse>
          <app-nav-item *ngIf="item.type === 'item'" [item]="item" [allowedPermissions]="contactNavPermissions" [isPhoneViewport]="isPhoneViewport"></app-nav-item>
        </ng-container>
      </ul>
    </ng-scrollbar>
  </div>

  <div class="bottom-nav-buttons">
    <div class="sidebar-divider" aria-hidden="true"></div>
    <ul class="bottom-nav-buttons__list">
      <li
        class="sidebar-language-item"
        *ngIf="showSidebarLanguage">
        <div
          class="sidebar-language"
          [class.is-open]="isLangDropdownOpen">
          <button
            type="button"
            class="nav-link sidebar-language-btn"
            (click)="toggleLangDropdown($event)"
            [attr.aria-expanded]="isLangDropdownOpen"
            aria-haspopup="listbox">
            <span class="sidebar-language-btn__content">
              <span class="sidebar-language-icon">
                <i-feather name="languages"></i-feather>
              </span>
              <span class="text">{{ getLanguageDisplayName(selectedLanguage) }}</span>
            </span>
            <i-feather
              [name]="isLangDropdownOpen ? 'chevron-up' : 'chevron-down'"
              class="sidebar-language-chevron"></i-feather>
          </button>
          <div
            class="sidebar-language-menu"
            [class.show]="isLangDropdownOpen"
            role="listbox">
            <div class="sidebar-language-menu-inner">
              <button
                *ngFor="let language of activeLanguages"
                type="button"
                class="sidebar-language-option"
                [class.active]="isLanguageSelected(language.code)"
                role="option"
                [attr.aria-selected]="isLanguageSelected(language.code)"
                (click)="changeSiteLanguage(language.code, $event)">
                {{ getLanguageDisplayName(language.code) }}
              </button>
            </div>
          </div>
        </div>
      </li>
      <li
        class="settings-item"
        *ngIf="userGroups.includes('admin')"
        [attr.title]="showTitle ? ('Settings' | translate) : null">
        <a class="nav-link settings-button" (click)="redirect()">
          <div class="settings-button-container">
            <span class="settings-icon">
              <i class="feather icon-settings"></i>
            </span>
            <span class="text">{{'Settings' | translate}}</span>
          </div>
        </a>
      </li>
      <li class="logout-item" [attr.title]="showTitle ? ('LogoutAccount' | translate) : null">
        <a class="nav-link logout-button" (click)="logout()">
          <div class="logout-button-container">
            <span class="logout-icon">
              <i class="feather icon-log-out"></i>
            </span>
            <span class="text">{{'LogoutAccount' | translate}}</span>
          </div>
        </a>
      </li>
    </ul>
  </div>
</div>
<div *ngIf="config?.layout === 'horizontal'" class="navbar-content sidenav-horizontal" id="layout-sidenav">
  <a href="javascript:" class="sidenav-horizontal-prev" [ngClass]="prevDisabled" (click)="scrollMinus()"></a>
  <div #navbarWrapper class="sidenav-horizontal-wrapper">
    <ul
      #navbarContent
      id="side-nav-horizontal"
      class="nav pcoded-inner-navbar sidenav-inner"
      (clickOutside)="fireLeave()"
      (mouseleave)="fireLeave()"
    >
      <ng-container *ngFor="let item of navigation">
        <app-nav-group *ngIf="item.type === 'group'" [item]="item" [allowedPermissions]="contactNavPermissions" [isPhoneViewport]="isPhoneViewport"></app-nav-group>
        <app-nav-collapse *ngIf="item.type === 'collapse'" [item]="item"></app-nav-collapse>
        <app-nav-item *ngIf="item.type === 'item'" [item]="item" [allowedPermissions]="contactNavPermissions" [isPhoneViewport]="isPhoneViewport"></app-nav-item>
      </ng-container>
    </ul>
  </div>
  <a href="javascript:" class="sidenav-horizontal-next" [ngClass]="nextDisabled" (click)="scrollPlus()"></a>
</div>
